module.exports = __webpack_public_path__ + "img/confirm1_th.09c92421.jpg";